/* eslint-disable import/prefer-default-export */
import styled from "styled-components";

export const StyledErrorMessage = styled.div`
  text-align: center;
  position: absolute;
  bottom: -20px;
  font-size: ${({ theme }) => theme.fontSize.small.desktop};
  color: ${({ theme }) => theme.colors.primary};
  font-weight: ${({ theme }) => theme.fontWeight.bolder};
  font-family: ${({ theme }) => theme.fontFamily};
  width: 100%;
`;

StyledErrorMessage.displayName = "StyledErrorMessage";
